module.exports = __webpack_public_path__ + "static/media/21.b77ff9d1.jpg";